(() => {
  if (window.SSNKAtelier) { window.SSNKAtelier.init(document); return; }
  const live = new Map();
  function setup(root) {
    if (root.dataset.activated) return;
    root.dataset.activated = 'true';
    const abort = new AbortController();
    const on = (node, event, fn, options = {}) => node?.addEventListener(event, fn, { ...options, signal: abort.signal });
    const config = JSON.parse(root.querySelector('[data-atelier-config]').textContent);
    const variants = JSON.parse(root.querySelector('[data-atelier-variants]').textContent) || [];
    const money = cents => new Intl.NumberFormat(config.locale || 'en', { style: 'currency', currency: config.currency || 'USD' }).format(cents / 100);
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const slides = [...root.querySelectorAll('[data-slide]')];
    const track = root.querySelector('[data-slides]');
    const thumbs = [...root.querySelectorAll('[data-thumb]')];
    let active = 0, frame = null;
    function mark(index) {
      active = Math.max(0, Math.min(index, slides.length - 1));
      thumbs.forEach((thumb, i) => thumb.setAttribute('aria-pressed', String(i === active)));
      const counter = root.querySelector('[data-gallery-count]');
      if (counter) counter.textContent = `${active + 1} / ${slides.length}`;
    }
    function go(index) {
      index = (index + slides.length) % slides.length;
      mark(index);
      track.scrollTo({ left: index * track.clientWidth, behavior: reduceMotion ? 'instant' : 'smooth' });
    }
    thumbs.forEach((thumb, index) => on(thumb, 'click', () => go(index)));
    on(root.querySelector('[data-gallery-prev]'), 'click', () => go(active - 1));
    on(root.querySelector('[data-gallery-next]'), 'click', () => go(active + 1));
    on(track, 'scroll', () => {
      if (frame) cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => { if (track.clientWidth) mark(Math.round(track.scrollLeft / track.clientWidth)); });
    }, { passive: true });
    let dialogOrigin;
    const dialogs = [...root.querySelectorAll('[data-dialog]')];
    function openDialog(dialog, origin) {
      if (!dialog) return;
      dialogOrigin = origin;
      dialog.showModal();
    }
    root.querySelectorAll('[data-dialog-open]').forEach(button => on(button, 'click', () => openDialog(root.querySelector(`[data-dialog="${button.dataset.dialogOpen}"]`), button)));
    dialogs.forEach(dialog => {
      on(dialog.querySelector('[data-dialog-close]'), 'click', () => dialog.close());
      on(dialog, 'click', event => { if (event.target === dialog) { const rect = dialog.getBoundingClientRect(); if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close(); } });
      on(dialog, 'close', () => dialogOrigin?.focus());
    });
    root.querySelectorAll('[data-zoom]').forEach(button => on(button, 'click', () => {
      const source = button.querySelector('img');
      if (!source) return;
      const image = root.querySelector('[data-zoom-image]');
      image.src = source.currentSrc || source.src;
      image.alt = source.alt;
      openDialog(root.querySelector('[data-dialog="zoom"]'), button);
    }));
    const form = root.querySelector('.at-form');
    const sticky = root.querySelector('[data-sticky]');
    let observer;
    if (form && variants.length) {
      const fields = [...form.querySelectorAll('[data-option-index]')];
      const select = form.querySelector('[data-variant-select]');
      const quantity = form.querySelector('[data-quantity-input]');
      const packs = [...form.querySelectorAll('[name^="atelier-pack-"]')];
      const packField = fields.find(field => [...field.querySelectorAll('input')].some(input => /^\d+ Pieces?$/.test(input.value)));
      const packIndex = packField ? fields.indexOf(packField) : 2;
      const packCount = variant => parseInt(variant?.options[packIndex] || '1', 10);
      const variantForPack = count => variants.find(variant => packCount(variant) === count && fields.every((field, index) => index === packIndex || variant.options[index] === field.querySelector('input:checked')?.value));
      if (packField) packField.hidden = true;
      const add = form.querySelector('[data-add]');
      const stickyAdd = root.querySelector('[data-sticky-add]');
      let current = variants.find(variant => String(variant.id) === select.value) || variants[0];
      const clampQuantity = () => {
        const raw = Number(quantity.value);
        const result = Math.min(99, Math.max(1, Number.isFinite(raw) ? Math.floor(raw) : 1));
        quantity.value = String(result);
        
        return result;
      };
      function render(updateUrl = false, updateImage = false) {
        const values = fields.map(field => {
          const selected = field.querySelector('input:checked');
          field.querySelector('[data-chosen]').textContent = selected?.value || '';
          return selected?.value;
        });
        current = variants.find(variant => variant.options.every((option, i) => option === values[i]));
        const available = !config.preview && Boolean(current?.available);
        const label = config.preview ? config.coming : !current ? config.unavailable : available ? config.add : config.sold;
        add.disabled = !available;
        add.querySelector('[data-add-label]').textContent = label;
        if (stickyAdd) { stickyAdd.disabled = !available; root.querySelector('[data-sticky-label]').textContent = label; }
        if (current) {
          if (![...select.options].some(option => option.value === String(current.id))) { const option = document.createElement('option'); option.value = String(current.id); option.textContent = current.title; select.add(option); }
          select.value = String(current.id);
          root.querySelector('[data-unit-price]').textContent = money(current.price);
          const compare = root.querySelector('[data-compare]');
          compare.hidden = !(current.compare_at_price > current.price);
          compare.textContent = compare.hidden ? '' : money(current.compare_at_price);
          const amount = current.price * clampQuantity();
          root.querySelector('[data-total]').textContent = money(amount);
          if (sticky) { root.querySelector('[data-sticky-selection]').textContent = `${current.title} · ${quantity.value}`; root.querySelector('[data-sticky-total]').textContent = money(amount); }
          packs.forEach(pack => { pack.checked = Number(pack.value) === packCount(current); });
          root.querySelectorAll('[data-pack-price]').forEach(el => {
            const variant = variantForPack(Number(el.dataset.packPrice));
            el.textContent = variant ? money(variant.price) : money(({1:2999,2:4999,3:5999})[el.dataset.packPrice]);
          });
          if (updateUrl && location.pathname.includes('/products')) { const url = new URL(location.href); url.searchParams.set('variant', String(current.id)); history.replaceState({}, '', url); }
          if (updateImage) {
            const colourField = fields.find(field => field.classList.contains('at-option-color'));
            const colour = colourField?.querySelector('input:checked')?.value;
            const index = slides.findIndex(slide => slide.dataset.color === colour);
            if (index >= 0) go(index);
          }
        } else {
          select.value = '';
          root.querySelector('[data-total]').textContent = '';
          if (sticky) { root.querySelector('[data-sticky-selection]').textContent = values.filter(Boolean).join(' / '); root.querySelector('[data-sticky-total]').textContent = ''; }
        }
      }
      fields.forEach(field => on(field, 'change', () => render(true, field.classList.contains('at-option-color'))));
      packs.forEach(pack => on(pack, 'change', () => {
        if (packField) {
          const input = [...packField.querySelectorAll('input')].find(input => parseInt(input.value, 10) === Number(pack.value));
          if (input) input.checked = true;
        }
        quantity.value = '1';
        render(true);
      }));
      on(quantity, 'change', () => render());
      form.querySelectorAll('[data-quantity]').forEach(button => on(button, 'click', () => { quantity.value = String(clampQuantity() + Number(button.dataset.quantity)); render(); }));
      on(form, 'submit', event => { if (!current?.available) { event.preventDefault(); return; } clampQuantity(); select.value = String(current.id); });
      root.classList.add('at-enhanced');
      render();
      if (sticky && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(entries => { for (const entry of entries) sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0; }, { threshold: 0 });
        observer.observe(add);
      }
    }
    live.set(root, () => { abort.abort(); observer?.disconnect(); if (frame) cancelAnimationFrame(frame); dialogs.forEach(dialog => { if (dialog.open) dialog.close(); }); live.delete(root); });
  }
  function init(scope) { if (scope.matches?.('[data-atelier]')) setup(scope); scope.querySelectorAll('[data-atelier]').forEach(setup); }
  window.SSNKAtelier = { init };
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => { for (const [root, dispose] of live) if (event.target.contains(root)) dispose(); });
})();

